<!-- Toasts with information for the user -->
<app-toasts [closeButtonAriaLabel]="labels.toast.closeButtonAriaLabel()" />

<router-outlet />

<!-- Show a loading animation when doing a API Call -->
<ng-http-loader
  [debounceDelay]="100"
  [minDuration]="300"
  [backdrop]="true"
  [filteredUrlPatterns]="filteredUrlPatterns"
  [entryComponent]="MyRegSpinnerComponent"
  backdropBackgroundColor="var(--http-loader-backdrop-background-color, #000000)"
  opacity=".7" />
